<template>
  <button class="btn" v-on="listeners">
    <span class="block">
      <slot>Click</slot>
    </span>
  </button>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  name: "CButton",
  computed: {
    listeners: function() {
      return {
        ...this.$listeners
      };
    }
  }
});
</script>

<style lang="postcss" scoped>
.btn {
  @apply outline-none appearance-none px-4 py-1;
  @apply shadow inline mx-1;
}
</style>

<style lang="postcss">
.btn-dark-rounded {
  @apply rounded bg-blue-700 text-white;
}

.btn-dark-rounded-full {
  @apply bg-blue-700 rounded-full text-white;
}
</style>